module.exports = __webpack_public_path__ + "static/media/backArrowLight.537ff288.svg";